import request from '@/utils/request'

/**
 * 会员流水查询 全部
 */

export function membersLiushui(type, data) {
  const urls = {
    'all': 'business/member_alipay_transfer_merge',
    'zhifubao': 'business/member_alipay',
    'outline': 'business/member_transfer_verify'
  }
  return request({
    url: urls[type],
    method: 'post',
    data: data
  })
}

/**
 * 直播数流水查询 全部
 */

export function zhiboshuLiushui(type, data) {
  const urls = {
    'all': 'business/zhiboshu_liushi_merge',
    'zhifubao': 'business/zhiboshu_liushi_alipay',
    'outline': 'business/zhiboshu_liushi_zhuanzhang'
  }
  return request({
    url: urls[type],
    method: 'post',
    data: data
  })
}

/**
 * 会议数流水查询 全部
 */

export function huiyishuLiushui(type, data) {
  const urls = {
    'all': 'business/huiyishi_liushi_merge',
    'zhifubao': 'business/huiyishi_liushi_alipay',
    'outline': 'business/huiyishi_liushi_zhuanzhang'
  }
  return request({
    url: urls[type],
    method: 'post',
    data: data
  })
}

/**
 * 调研报告流水查询 全部
 */

export function diaoyanLiushui(type, data) {
  const urls = {
    'all': 'business/diaoyan_liushi_merge',
    'zhifubao': 'business/diaoyan_liushi_alipay',
    'outline': 'business/diaoyan_liushi_zhuanzhang'
  }
  return request({
    url: urls[type],
    method: 'post',
    data: data
  })
}

/**
 * 流量获取详情数据
 */

export function liuliangDetail(type, data) {
  const urls = {
    'live': 'business/zhiboshu_liushui_info',
    'meeting': 'business/huiyishi_liushui_info',
    'diaoyan': 'business/diaoyan_liushui_info'
  }
  return request({
    url: urls[type],
    method: 'post',
    data: data
  })
}

/**
 * 流量审核
 */

export function liuliangCheck(type, data) {
  const urls = {
    'live': 'business/zhiboshu_liushui_shenhe',
    'meeting': 'business/huiyishi_liushui_shenhe',
    'diaoyan': 'business/diaoyan_liushui_shenhe'
  }
  return request({
    url: urls[type],
    method: 'post',
    data: data,
    formData: true
  })
}
